import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CartSelector from 'views/cart/cart.selector';
import { propsToJS } from '__utils/immutable-to-js';
import PaymentModeSelection from './payment-mode-selection';
import PaymentOtpVerification from './payment-otp-verification';
import { getTotalCartInvestmentAmountFromCartDetails, isBtoCFlow } from '__utils/common-utils';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { getAgentCode, getUserDetails } from '__utils/storage';
import { fetchPost, get, getDefaultHeaders, getFormDataFromJson } from '__utils/ajax-wrapper';
import { ENDPOINTS } from 'constants/endpoints';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import useFlashToggler from 'hooks/use-flash-toggler';
import { PAYMENT_MODE } from 'constants/payment-modes';
import { PaymentFlowHelper } from 'views/payment-flow/paymentFlow.helper';
import PaymentViewSelector from 'views/payment-flow/payment-flow.selector';

interface paymentProps {
    onClose?: Function;
    cartId?: string;
}

const PaymentMode: React.FC<paymentProps> = ({ onClose, cartId }: paymentProps) => {
    const history = useHistory();
    const { makeBSEpayment } = PaymentFlowHelper();
    const flash = useFlashToggler();
    const [ stage, setStage ] = useState<'payment-mode-selection' | 'payment-otp-verification'>('payment-otp-verification');
    const [ highRiskWarning, setHighRiskWarning ] = useState<boolean>(false);
    const { cartDetails } = propsToJS(useSelector(CartSelector));
    const { loopBackURL  } = propsToJS(useSelector(PaymentViewSelector));

    useEffect(() => {
        if (stage === 'payment-otp-verification')
        {
            sendTransactionOtp();
        }
    }, []);
    const sendTransactionOtp = () => {
        get(
            `${ENDPOINTS.GET_SEND_TRANSACTION_OTP}?flowType=1&cartId=${cartId}`,
            getDefaultHeaders(),
            true
        ).subscribe((response: AjaxResponse | AjaxError) => {
            setHighRiskWarning(response?.response?.responseData);
        }, (error: AjaxError) => {
            console.log(error);
        });
    }

    const verifyTransactionOTP = (otp: number): void => {
        const formData = getFormDataFromJson({ otp: '' + otp, flowType: 1 });
         fetchPost(
             `${ENDPOINTS.POST_VERIFY_TRANSACTION_OTP}?cartId=${cartId}`, formData, null, true
         ).then((response: any) => {
             if (response && response.operationMessage === "success")
             {
                 Mixpanel.track(getEventName("paymentOTPVerification", "completed", "payment"), {
                     agentCode: getAgentCode(),
                     user: getUserDetails(),
                     isBtoCFlow: isBtoCFlow(),
                 });
                redirectAfterOtpVerification();
             } else if(response.operationMessage === "failure" && response?.responseData?.expired){
                flash.error("Your OTP has expired. Please request a new OTP to complete your transaction");
             }
             else flash.error("Please enter correct OTP.");
         }).catch((error: any) => {
             flash.error("Failed to verify OTP.");
         })
    }

    const redirectAfterOtpVerification = () => {
        setStage('payment-mode-selection');
    }

    const onNetBankingSuccess = (responseData:any) => {
        document.open();
        document.write(responseData);
        document.close();
    }

    const onOtmPaymentSuccess = (responseData:any) => {
        window.open(responseData, '_self');
    }

    const onPaymentModeSelect = (paymentData: any) => {
        Mixpanel.track(getEventName("paymentMode", "selected", "payment"), {
            paymentMode: paymentData.paymentMode,
        });

        if (paymentData.paymentMode == PAYMENT_MODE.NET_BANKING)
        {
            makeBSEpayment({ paymentMode: PAYMENT_MODE.NET_BANKING },onNetBankingSuccess);
        }
        else if (paymentData.paymentMode == PAYMENT_MODE.CHEQUE)
        {
            history.push(`cheque-payment?loopBackUrl=${loopBackURL.split('/')[4]}`);

        } else if (paymentData.paymentMode == PAYMENT_MODE.NEFT)
        {
            history.push(`/neft-payment?loopBackUrl=${loopBackURL.split('/')[4]}`);

        } else if (paymentData.paymentMode == PAYMENT_MODE.UPI)
        {
            history.push(`/upi-payment?loopBackUrl=${loopBackURL.split('/')[4]}`);
        } else if (paymentData.paymentMode == PAYMENT_MODE.OTM) {
            makeBSEpayment({ paymentMode: PAYMENT_MODE.OTM }, onOtmPaymentSuccess);
        }


    }

    return stage === 'payment-mode-selection' ? <PaymentModeSelection
        onClose={ onClose }
        totalCartInvestmentAmount={ getTotalCartInvestmentAmountFromCartDetails(cartDetails) }
        onSelectPaymentMode={ onPaymentModeSelect }
    /> : stage === 'payment-otp-verification' ? <PaymentOtpVerification
        onClose={ onClose }
        onVerifyOtp={ verifyTransactionOTP }
        onResendOtp={ sendTransactionOtp }
        highRiskWarning={ highRiskWarning }
    /> : null;
}

export default PaymentMode;